import {
    TutorialIntroModalVideoPlayButtonInnerCircleStyled,
    TutorialIntroModalVideoPlayButtonStyled,
} from './styled/TutorialIntroModalVideoPlayButtonStyled';
import BinIcon from '../../../../../components/icon/Icon';
import classNames from 'classnames';

interface IVideoPlayButtonProps {
    hover?: boolean;
}

function TutorialIntroModalVideoPlayButton(props: IVideoPlayButtonProps) {
    const { hover } = props;

    return <TutorialIntroModalVideoPlayButtonStyled>
        <TutorialIntroModalVideoPlayButtonInnerCircleStyled className={classNames({ 'hover': hover })}>
            <BinIcon name='IcPlay' size={24}/>
        </TutorialIntroModalVideoPlayButtonInnerCircleStyled>
    </TutorialIntroModalVideoPlayButtonStyled>;
}

export default TutorialIntroModalVideoPlayButton;
